import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';

export interface TransitionUniDriver extends BaseUniDriver {
  hasAnimationStarted(): Promise<boolean>;
}
